export default "__VITE_ASSET__CGHyc2Ta__"